import axios from "../axios-config";


export const searchArtistApi = async ({ name }) => {
    const response = await axios.get(`/user/v1/search-artist`, {
        params: { name },
    });
    return response?.data?.data || [];
};


export const assignArtistToUserApi = async (payload) => {
    const res = await axios.post("/user/v1/assign-artist-to-user", payload);
    return res.data;
};